export const actionTypeConstants = {
  CREATE: "CREATE",
  UPDATE: "UPDATE"
};
